import type { GlobalAppSlug } from "@/lib/dashboardAppRegistry";
import { DASHBOARD_APP_ORDER, DASHBOARD_APP_BY_SLUG } from "@/lib/dashboardAppRegistry";
import { canAccessPlatformApp } from "@/lib/atwPlatformOrg";
import { expandStaleFullOneEntitlements } from "@/lib/tenantAppEntitlements";

const DASHBOARD_APP_ORDER_CORE: GlobalAppSlug[] = DASHBOARD_APP_ORDER.filter(
  (s): s is Exclude<GlobalAppSlug, "platform"> => s !== "platform",
);

export function getRoleBaseDashboardAppSlugs(role: string | undefined): GlobalAppSlug[] {
  const r = role || "standard_user";
  if (
    r === "super_admin" ||
    r === "account_owner" ||
    r === "account_admin" ||
    r === "manager" ||
    r === "standard_user" ||
    r === "limited_user" ||
    r === "read_only" ||
    r === "admin" ||
    r === "editor" ||
    r === "author" ||
    r === "viewer"
  ) {
    return [...DASHBOARD_APP_ORDER_CORE];
  }
  if (r === "billing_admin") {
    return ["home", "finance", "pay", "marketing", "custom-apps"];
  }
  return [...DASHBOARD_APP_ORDER_CORE];
}

export function getEffectiveDashboardAppSlugs(
  role: string | undefined,
  appEntitlements: GlobalAppSlug[] | null | undefined,
  dashboardOrgId?: string | null,
): GlobalAppSlug[] {
  const r = role || "standard_user";
  let out: GlobalAppSlug[];
  if (r === "super_admin" || r === "account_owner") {
    out = [...DASHBOARD_APP_ORDER_CORE];
    if (r === "super_admin" && canAccessPlatformApp(dashboardOrgId, r)) {
      out.push("platform");
    }
  } else if (appEntitlements === undefined || appEntitlements === null) {
    out = getRoleBaseDashboardAppSlugs(r);
  } else {
    const valid = new Set<string>(DASHBOARD_APP_ORDER);
    const chosen = expandStaleFullOneEntitlements(
      appEntitlements.filter((s): s is GlobalAppSlug => valid.has(s)),
    );
    const set = new Set<GlobalAppSlug>(["home", ...chosen]);
    out = DASHBOARD_APP_ORDER.filter((s) => {
      if (!set.has(s)) return false;
      if (s === "platform") return canAccessPlatformApp(dashboardOrgId, r);
      return true;
    });
  }
  return out;
}

export { DASHBOARD_APP_BY_SLUG };
